module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/golfing@2x_6047c4.jpg";